<dt-modal-content (closeClick)="close()" [contentPadding]="false">
  <ng-template #title i18n>Seiten des Fragebogens neu anordnen</ng-template>
  <ng-template #content>
    <p i18n>Die Seiten des Fragebogens können hier neu angeordnet werden.</p>
    <div cdkDropList (cdkDropListDropped)="onDrop($event)">
      @for (page of pageOrder; track page) {
        <div class="list-item" cdkDrag>
          <mat-icon>drag_handle</mat-icon>
          <ng-container i18n>Seite {{ page + 1 }}</ng-container>
        </div>
      }
    </div>
  </ng-template>
  <ng-template #footer>
    <button mat-raised-button color="primary" (click)="close(true)" i18n>Speichern</button>
    <button mat-raised-button (click)="close()" i18n>Verwerfen</button>
  </ng-template>
</dt-modal-content>
